import { Tabs, Tab, DrawerBody, DrawerTitle } from "@growtherapy/sprout-ui";
import { useState } from "react";
import { DrawerHeader } from "../DrawerHeader";
import {
  faImageUser,
  faMicrophone,
  faUniversalAccess,
  faVideo,
} from "@fortawesome/pro-solid-svg-icons";

export enum SettingsDrawerTab {
  VIDEO = "video",
  AUDIO = "audio",
  BACKGROUND = "background",
  ACCESSIBILITY = "accessibility",
}

export type TabMap = Record<SettingsDrawerTab, JSX.Element | undefined>;

export function SettingsDrawer({ tabMap }: { tabMap: TabMap }) {
  const [selectedTab, setSelectedTab] = useState<SettingsDrawerTab>(
    SettingsDrawerTab.VIDEO,
  );

  return (
    <>
      <DrawerHeader>
        <DrawerTitle>Settings</DrawerTitle>
      </DrawerHeader>
      <DrawerBody>
        <Tabs
          selectedTabId={selectedTab}
          onSelectTab={(newTab: SettingsDrawerTab) => {
            setSelectedTab(newTab);
          }}
          className="w-full overflow-x-scroll no-scrollbar flex gap-2"
        >
          {/**
           * Fragmnets used below because the Tabs component is very strict
           * about its child types - null, undefined, etc. are not allowed
           */}
          {SettingsDrawerTab.VIDEO in tabMap ? (
            <Tab
              tabId="video"
              className="whitespace-nowrap"
              icon={faVideo}
              title="Video"
            />
          ) : (
            <></>
          )}
          {SettingsDrawerTab.AUDIO in tabMap ? (
            <Tab
              tabId="audio"
              className="whitespace-nowrap"
              icon={faMicrophone}
              title="Audio"
            />
          ) : (
            <></>
          )}
          {SettingsDrawerTab.BACKGROUND in tabMap ? (
            <Tab
              tabId="background"
              className="whitespace-nowrap"
              icon={faImageUser}
              title="Background"
            />
          ) : (
            <></>
          )}
          {SettingsDrawerTab.ACCESSIBILITY in tabMap ? (
            <Tab
              tabId="accessibility"
              className="whitespace-nowrap"
              icon={faUniversalAccess}
              title="Accessibility"
            />
          ) : (
            <></>
          )}
        </Tabs>
        {tabMap[selectedTab]}
      </DrawerBody>
    </>
  );
}
